export const PANEL_GROUP_NAMES = ["Change Over ATS", "ATS", "CB"] as const;


export function parsePanelLabel(
	label: string | null | undefined,
): { group: string; option: string; qty: number } | null {
	const text = (label ?? "").trim();
	for (const group of PANEL_GROUP_NAMES) {
		const prefix = `${group} - `;
		if (!text.startsWith(prefix)) continue;
		const rest = text.slice(prefix.length);
		const qtyMatch = rest.match(/^(.*)\sx(\d+)$/);
		if (qtyMatch) {
			return { group, option: qtyMatch[1]!.trim(), qty: Number(qtyMatch[2]) || 1 };
		}
		return { group, option: rest.trim(), qty: 1 };
	}
	return null;
}

export function isGeneratedLine(line: {
	itemCode?: string | null;
	stockItemId?: string | null;
}): boolean {
	return !line.itemCode && !line.stockItemId;
}
